import React from 'react';
import Box, { BoxProps } from '@mui/material/Box';

/** Thick enough for the four statuses to read as colour at a glance, thin enough to stay a bar. */
export const METER_HEIGHT = 12;
export const METER_TRACK = '#EEF1F5';

/**
 * The empty rail a meter is drawn on. Its children are the filled segments, laid side by side
 * with a hairline gap, so a stacked share and a single fill use the same track.
 */
const MeterTrack: React.FC<{ sx?: BoxProps['sx']; children?: React.ReactNode }> = ({
  sx,
  children,
}) => (
  <Box
    display="flex"
    gap="2px"
    width="100%"
    height={METER_HEIGHT}
    borderRadius={1}
    overflow="hidden"
    position="relative"
    sx={[{ backgroundColor: METER_TRACK }, ...(Array.isArray(sx) ? sx : [sx])]}
  >
    {children}
  </Box>
);

export default MeterTrack;
